const catalog = {
  en: {
    inlineTooLarge:
      '{name} is larger than 4 MB, too large to send with a message. Choose Add company context (@), then Upload a company file: it is saved to the Library and attached, and Poneva reads it page by page.',
    businessTooLarge:
      '{name} is too large to read in chat. Choose a copy under 50 MiB, or save the original in Library.',
    chatHeadUnavailable: 'This chat is unavailable. Reload it before sending.',
  },
  bg: {
    inlineTooLarge:
      '{name} е по-голям от 4 MB и е твърде голям, за да бъде изпратен със съобщение. Изберете „Добавяне на фирмен контекст (@)“, след това „Качване на фирмен файл“: той ще бъде запазен в Библиотеката и прикачен, а Poneva ще го прочете страница по страница.',
    businessTooLarge:
      '{name} е твърде голям, за да бъде прочетен в чата. Изберете копие под 50 MiB или запазете оригинала в Библиотеката.',
    chatHeadUnavailable: 'Този чат не е наличен. Презаредете го, преди да изпратите съобщение.',
  },
  hr: {
    inlineTooLarge:
      '{name} je veća od 4 MB i prevelika je za slanje uz poruku. Odaberite Dodaj kontekst tvrtke (@), zatim Prenesi datoteku tvrtke: ona će se spremiti u Biblioteku i priložiti, a Poneva će je čitati stranicu po stranicu.',
    businessTooLarge:
      '{name} je prevelika za čitanje u chatu. Odaberite kopiju manju od 50 MiB ili spremite izvornik u Biblioteku.',
    chatHeadUnavailable: 'Ovaj chat nije dostupan. Ponovno ga učitajte prije slanja.',
  },
  cs: {
    inlineTooLarge:
      '{name} je větší než 4 MB a nelze jej odeslat se zprávou. Zvolte Přidat kontext společnosti (@) a poté Nahrát firemní soubor: uloží se do Knihovny a připojí se ke zprávě. Poneva jej přečte stránku po stránce.',
    businessTooLarge:
      '{name} je příliš velký na přečtení v chatu. Zvolte kopii menší než 50 MiB nebo uložte originál do Knihovny.',
    chatHeadUnavailable: 'Tento chat není k dispozici. Před odesláním jej znovu načtěte.',
  },
  da: {
    inlineTooLarge:
      '{name} er større end 4 MB og for stor til at sende med en besked. Vælg Tilføj virksomhedskontekst (@), og vælg derefter Upload en virksomhedsfil: Den gemmes i Biblioteket og vedhæftes, og Poneva læser den side for side.',
    businessTooLarge:
      '{name} er for stor til at blive læst i chatten. Vælg en kopi på under 50 MiB, eller gem originalen i Biblioteket.',
    chatHeadUnavailable: 'Denne chat er ikke tilgængelig. Genindlæs den, før du sender.',
  },
  nl: {
    inlineTooLarge:
      '{name} is groter dan 4 MB en te groot om met een bericht te verzenden. Kies Bedrijfscontext toevoegen (@) en vervolgens Een bedrijfsbestand uploaden: het bestand wordt opgeslagen in de Bibliotheek en bijgevoegd, waarna Poneva het pagina voor pagina leest.',
    businessTooLarge:
      '{name} is te groot om in de chat te lezen. Kies een kopie van minder dan 50 MiB of sla het origineel op in de Bibliotheek.',
    chatHeadUnavailable:
      'Deze chat is niet beschikbaar. Laad de chat opnieuw voordat je een bericht verzendt.',
  },
  et: {
    inlineTooLarge:
      '{name} on suurem kui 4 MB ja seda ei saa sõnumiga saata. Valige Lisa ettevõtte kontekst (@) ja seejärel Laadi üles ettevõttefail: see salvestatakse teeki ja lisatakse manuseks ning Poneva loeb selle lehekülgede kaupa.',
    businessTooLarge:
      '{name} on vestluses lugemiseks liiga suur. Valige alla 50 MiB suurune koopia või salvestage originaal teeki.',
    chatHeadUnavailable: 'See vestlus pole saadaval. Laadige see enne saatmist uuesti.',
  },
  fi: {
    inlineTooLarge:
      '{name} on suurempi kuin 4 Mt, joten se on liian suuri lähetettäväksi viestin mukana. Valitse Lisää yrityksen konteksti (@) ja sitten Lataa yritystiedosto: tiedosto tallennetaan kirjastoon ja liitetään viestiin, ja Poneva lukee sen sivu kerrallaan.',
    businessTooLarge:
      '{name} on liian suuri chatissa luettavaksi. Valitse alle 50 MiB:n kokoinen kopio tai tallenna alkuperäinen kirjastoon.',
    chatHeadUnavailable: 'Tämä chat ei ole käytettävissä. Lataa se uudelleen ennen lähettämistä.',
  },
  fr: {
    inlineTooLarge:
      '{name} fait plus de 4 Mo et est trop volumineux pour être envoyé avec un message. Choisissez Ajouter un contexte d’entreprise (@), puis Importer un fichier d’entreprise : il sera enregistré dans la Bibliothèque et joint au message, et Poneva le lira page par page.',
    businessTooLarge:
      '{name} est trop volumineux pour être lu dans le chat. Choisissez une copie de moins de 50 Mio ou enregistrez l’original dans la Bibliothèque.',
    chatHeadUnavailable: 'Ce chat n’est pas disponible. Rechargez-le avant d’envoyer un message.',
  },
  de: {
    inlineTooLarge:
      '{name} ist größer als 4 MB und zu groß, um mit einer Nachricht gesendet zu werden. Wählen Sie „Unternehmenskontext hinzufügen (@)“ und dann „Unternehmensdatei hochladen“: Sie wird in der Bibliothek gespeichert und angehängt, und Poneva liest sie Seite für Seite.',
    businessTooLarge:
      '{name} ist zu groß, um im Chat gelesen zu werden. Wählen Sie eine Kopie mit weniger als 50 MiB oder speichern Sie das Original in der Bibliothek.',
    chatHeadUnavailable:
      'Dieser Chat ist nicht verfügbar. Laden Sie ihn neu, bevor Sie eine Nachricht senden.',
  },
  el: {
    inlineTooLarge:
      'Το {name} είναι μεγαλύτερο από 4 MB και πολύ μεγάλο για αποστολή με μήνυμα. Επιλέξτε «Προσθήκη εταιρικού περιεχομένου (@)» και, στη συνέχεια, «Μεταφόρτωση εταιρικού αρχείου»: αποθηκεύεται στη Βιβλιοθήκη και επισυνάπτεται, ενώ το Poneva το διαβάζει σελίδα προς σελίδα.',
    businessTooLarge:
      'Το {name} είναι πολύ μεγάλο για ανάγνωση στη συνομιλία. Επιλέξτε ένα αντίγραφο μικρότερο από 50 MiB ή αποθηκεύστε το πρωτότυπο στη Βιβλιοθήκη.',
    chatHeadUnavailable:
      'Αυτή η συνομιλία δεν είναι διαθέσιμη. Φορτώστε την ξανά πριν στείλετε μήνυμα.',
  },
  hu: {
    inlineTooLarge:
      'A(z) {name} mérete meghaladja a 4 MB-ot, ezért túl nagy ahhoz, hogy üzenettel elküldd. Válaszd a Céges kontextus hozzáadása (@) lehetőséget, majd a Céges fájl feltöltése opciót: a fájl a Könyvtárba kerül, és csatolva lesz, a Poneva pedig oldalanként olvassa be.',
    businessTooLarge:
      'A(z) {name} túl nagy ahhoz, hogy a csevegésben be lehessen olvasni. Válassz egy 50 MiB-nál kisebb másolatot, vagy mentsd az eredetit a Könyvtárba.',
    chatHeadUnavailable: 'Ez a csevegés nem érhető el. Küldés előtt töltsd újra.',
  },
  ga: {
    inlineTooLarge:
      'Tá {name} níos mó ná 4 MB, agus tá sé rómhór le seoladh i dteachtaireacht. Roghnaigh Cuir comhthéacs cuideachta leis (@), ansin Uaslódáil comhad cuideachta: sábháiltear sa Leabharlann é agus ceanglaítear é, agus léann Poneva é leathanach ar leathanach.',
    businessTooLarge:
      'Tá {name} rómhór le léamh sa chomhrá. Roghnaigh cóip atá faoi bhun 50 MiB, nó sábháil an bunleagan sa Leabharlann.',
    chatHeadUnavailable: 'Níl an comhrá seo ar fáil. Athlódáil é sula seolfaidh tú.',
  },
  it: {
    inlineTooLarge:
      '{name} supera i 4 MB e non può essere inviato con un messaggio. Seleziona Aggiungi contesto aziendale (@), quindi Carica un file aziendale: verrà salvato nella Libreria e allegato, e Poneva lo leggerà pagina per pagina.',
    businessTooLarge:
      '{name} è troppo grande per essere letto nella chat. Scegli una copia inferiore a 50 MiB oppure salva l’originale nella Libreria.',
    chatHeadUnavailable: 'Questa chat non è disponibile. Ricaricala prima di inviare il messaggio.',
  },
  lv: {
    inlineTooLarge:
      '{name} ir lielāks par 4 MB, tāpēc to nevar nosūtīt kopā ar ziņu. Izvēlieties Pievienot uzņēmuma kontekstu (@), pēc tam Augšupielādēt uzņēmuma failu: tas tiks saglabāts Bibliotēkā un pievienots, un Poneva to izlasīs pa lapām.',
    businessTooLarge:
      '{name} ir pārāk liels, lai to izlasītu tērzēšanā. Izvēlieties kopiju, kas ir mazāka par 50 MiB, vai saglabājiet oriģinālu Bibliotēkā.',
    chatHeadUnavailable: 'Šī tērzēšana nav pieejama. Pirms nosūtīšanas atkārtoti ielādējiet to.',
  },
  lt: {
    inlineTooLarge:
      '{name} yra didesnis nei 4 MB, todėl per didelis siųsti su žinute. Pasirinkite Pridėti įmonės kontekstą (@), tada Įkelti įmonės failą: jis bus išsaugotas Bibliotekoje ir pridėtas, o Poneva jį perskaitys puslapis po puslapio.',
    businessTooLarge:
      '{name} yra per didelis, kad jį būtų galima perskaityti pokalbyje. Pasirinkite mažesnę nei 50 MiB kopiją arba išsaugokite originalą Bibliotekoje.',
    chatHeadUnavailable: 'Šis pokalbis nepasiekiamas. Prieš siųsdami iš naujo įkelkite jį.',
  },
  mt: {
    inlineTooLarge:
      '{name} huwa ikbar minn 4 MB, kbir wisq biex jintbagħat ma’ messaġġ. Agħżel Żid kuntest tal-kumpanija (@), imbagħad Tella’ fajl tal-kumpanija: dan jiġi ssejvjat fil-Librerija u mehmuż, u Poneva jaqrah paġna paġna.',
    businessTooLarge:
      '{name} huwa kbir wisq biex jinqara fiċ-chat. Agħżel kopja ta’ inqas minn 50 MiB, jew issalva l-oriġinal fil-Librerija.',
    chatHeadUnavailable: 'Din iċ-chat mhijiex disponibbli. Erġa’ għabbiha qabel tibgħat.',
  },
  pl: {
    inlineTooLarge:
      '{name} ma więcej niż 4 MB i jest zbyt duży, aby wysłać go z wiadomością. Wybierz Dodaj kontekst firmy (@), a następnie Prześlij plik firmowy: zostanie zapisany w Bibliotece i dołączony, a Poneva odczyta go strona po stronie.',
    businessTooLarge:
      '{name} jest zbyt duży, aby odczytać go na czacie. Wybierz kopię mniejszą niż 50 MiB albo zapisz oryginał w Bibliotece.',
    chatHeadUnavailable: 'Ten czat jest niedostępny. Odśwież go przed wysłaniem wiadomości.',
  },
  pt: {
    inlineTooLarge:
      '{name} é maior que 4 MB e grande demais para enviar com uma mensagem. Selecione Adicionar contexto da empresa (@) e escolha Enviar um arquivo da empresa: ele será salvo na Biblioteca e anexado, e o Poneva o lerá página por página.',
    businessTooLarge:
      '{name} é grande demais para ser lido no chat. Escolha uma cópia com menos de 50 MiB ou salve o original na Biblioteca.',
    chatHeadUnavailable: 'Este chat está indisponível. Recarregue-o antes de enviar.',
  },
  ro: {
    inlineTooLarge:
      '{name} depășește 4 MB și este prea mare pentru a fi trimis(ă) într-un mesaj. Selectează Adaugă contextul companiei (@), apoi Încarcă un fișier al companiei: acesta este salvat în Bibliotecă și atașat, iar Poneva îl citește pagină cu pagină.',
    businessTooLarge:
      '{name} este prea mare pentru a fi citit în chat. Alege o copie de sub 50 MiB sau salvează originalul în Bibliotecă.',
    chatHeadUnavailable: 'Acest chat nu este disponibil. Reîncarcă-l înainte de a trimite.',
  },
  sk: {
    inlineTooLarge:
      '{name} je väčší než 4 MB a nedá sa odoslať so správou. Vyberte Pridať kontext spoločnosti (@) a potom Nahrať súbor spoločnosti: uloží sa do Knižnice a pripojí, pričom Poneva ho prečíta po jednotlivých stranách.',
    businessTooLarge:
      '{name} je príliš veľký na prečítanie v chate. Vyberte kópiu menšiu než 50 MiB alebo uložte originál do Knižnice.',
    chatHeadUnavailable: 'Tento chat nie je dostupný. Pred odoslaním ho znova načítajte.',
  },
  sl: {
    inlineTooLarge:
      '{name} je večja od 4 MB, zato je prevelika za pošiljanje s sporočilom. Izberite Dodaj kontekst podjetja (@) in nato Naloži datoteko podjetja: datoteka se shrani v Knjižnico in priloži, Poneva pa jo prebere stran za stranjo.',
    businessTooLarge:
      '{name} je prevelika za branje v klepetu. Izberite kopijo, manjšo od 50 MiB, ali shranite izvirnik v Knjižnico.',
    chatHeadUnavailable: 'Ta klepet ni na voljo. Pred pošiljanjem ga znova naložite.',
  },
  es: {
    inlineTooLarge:
      '{name} supera los 4 MB; es demasiado grande para enviarlo con un mensaje. Elige Añadir contexto de la empresa (@) y, después, Subir un archivo de la empresa: se guardará en la Biblioteca y se adjuntará, y Poneva lo leerá página por página.',
    businessTooLarge:
      '{name} es demasiado grande para leerlo en el chat. Elige una copia de menos de 50 MiB o guarda el original en la Biblioteca.',
    chatHeadUnavailable:
      'Este chat no está disponible. Vuelve a cargarlo antes de enviar mensajes.',
  },
  sv: {
    inlineTooLarge:
      '{name} är större än 4 MB och kan inte skickas med ett meddelande. Välj Lägg till företagskontext (@) och sedan Ladda upp en företagsfil: den sparas i Biblioteket och bifogas, och Poneva läser den sida för sida.',
    businessTooLarge:
      '{name} är för stor för att läsas i chatten. Välj en kopia på under 50 MiB eller spara originalet i Biblioteket.',
    chatHeadUnavailable: 'Den här chatten är inte tillgänglig. Ladda om den innan du skickar.',
  },
};
export type AttachmentErrorKey = keyof typeof catalog.en;
export default catalog;
